import { Create } from "react-admin";
import { useAdmin } from "../../hooks/admin";
import { CourseForm } from "./_form";

export const CourseCreate = () => {
  const { hasPermission } = useAdmin();

  if (!hasPermission("course.create")) return null;

  return (
    <Create redirect="show">
      <CourseForm />
    </Create>
  );
};
